"use strict";
exports.isMatch = isMatch;
var _index = require("./isValid.js");
var _index2 = require("./parse.js");
function isMatch(dateStr, formatStr, options) {
  return (0, _index.isValid)(
    (0, _index2.parse)(dateStr, formatStr, /* @__PURE__ */ new Date(), options)
  );
}
